<template>
<div class="withdraw">
  <div v-for="paytype in payTypeList">
    <withdraw-card
      :withdraw-pay-info="bankCardInfo"
      v-if="paytype.id == 4 &&paytype.status == 0"
    ></withdraw-card>
    <withdraw-card
      :withdraw-pay-info="usdtCardInfo"
      v-if="paytype.id == 5 &&paytype.status == 0"
    ></withdraw-card>
    <withdraw-card
      :withdraw-pay-info="otcCardInfo"
      v-if="paytype.id == 6 &&paytype.status == 0"
    ></withdraw-card>
  </div>
  
</div>
</template>

<script>
// 出金
import bankIconUrl from '../../../../assets/images/founds/bankTw.png';
import usdtIconUrl from '../../../../assets/images/founds/usdtIcon.png';
import otcIconUrl from '../../../../assets/images/founds/otcIconNew.png';
import { getBankInfo, getUSDExRateAndFee } from '@/api/userCenter'
import withdrawCard from "@/components/withdraw/withdrawCard";
import { mapGetters } from 'vuex';
import { queryTPayType } from '@/api/userCenter'
export default {
  name: "index",
  components:{
    withdrawCard,
  },
  data() {
    return {
      withdrawList: [],
      payTypeList:[],
      bankInfo: {
        examineStatus: '',
        payDetailMap:{
          bankAccount: "",
          bankName: "",
          bankStatus: 0,
          firstName: "",
          lastName: "",
          swiftCode: "",
        },
        maximumLimit: 0,
        minimumLimit: 0,
      },
      bankOutMoney: {},
      usdtInfo:{
        payDetailMap:{
          address: "",
          qrPic: "",
        },
        maximumLimit: 0,
        minimumLimit: 0
      },
      otcInfo:{
        payDetailMap:{
          address: "",
          qrPic: "",
        },
        maximumLimit: 0,
        minimumLimit: 0
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    bankMinimumLimit(){
      return this.bankOutMoney.minimumLimit || this.bankInfo.minimumLimit;
    },
    bankCardInfo(){
      return {
        payTypeId: 4,
        channelName: this.$t('Bank_card'),
        logoUrl: bankIconUrl,
        descs: [
          `1.${this.$t('User.limit')}$${this.bankMinimumLimit}~$${this.bankMaximunLimit}。`,
          this.$t('withdrawBankCardTipsSecondLine'),
          '3.' + this.$t('withdrawBankCardTipsThirdlyLine'),
        ]
      }
    },
    bankMaximunLimit(){
      return this.bankOutMoney.maximumLimit || this.bankInfo.maximumLimt || '∞';
    },
    usdtCardInfo(){
      return {
        payTypeId: 5,
        channelName: 'USDT',
        logoUrl: usdtIconUrl,
        descs: [
          `1.${this.$t('User.limit')}$${this.usdtMinimumLimit}~$${this.usdtMaximumLimit}。`,
          this.$t('withdrawUsdtTipsSecondLine'),
          '3.' + this.$t('withdrawBankCardTipsThirdlyLine'),
        ]
      }
    },
    usdtMinimumLimit(){
      return this.usdtInfo.minimumLimit
    },
    usdtMaximumLimit(){
      return this.usdtInfo.maximumLimt || '∞';
    },
    otcCardInfo(){
      return {
        payTypeId: 6,
        channelName: this.$t('withdraw365'),
        logoUrl: otcIconUrl,
        descs: [
          `1.${this.$t('User.limit')}$${this.otcMinimumLimit}~$${this.otcMaximumLimit}。`,
          '2.' + this.$t('withdrawOtcTipsSecondLine'),
          '3.' + this.$t('withdrawOtcTipThirdlyLine'),
          '4.' + this.$t('withdrawBankCardTipsThirdlyLine'),
        ]
      }
    },
    otcMinimumLimit(){
      return this.otcInfo.minimumLimit;
    },
    otcMaximumLimit(){
      return this.otcInfo.maximumLimt || '∞';
    }
  },
  created(){
    //获取出金方式
    this.getPayType();
    this.getWithdrawList();
  },
  methods: {
    queryTPayType,
    getPayType(){
      queryTPayType({
        oprType: 2,
      }).then((res) => {
        this.payTypeList = res.data;
      })
    },
    getWithdrawList(){
      getBankInfo({
        custId: this.userInfo.id,
        type: 1,
      }).then((res) => {
        this.withdrawList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          if(res.data[i].payTypeId == 4){
            this.bankInfo = res.data[i];
            this.getUSDExRateAndFee();
          }
          if(res.data[i].payTypeId == 5){
            this.usdtInfo = res.data[i];
          }
          if(res.data[i].payTypeId == 6){
            this.otcInfo = res.data[i];
          }
        }
      })
    },
    getUSDExRateAndFee() {
      let params = {
        oprType: 2,
        depCurrency: this.bankInfo.payDetailMap.currency
      };
      getUSDExRateAndFee(params).then((res) => {
        this.bankOutMoney = res.data[0] ? res.data[0] : {};
      });
    },
  },
}
</script>

<style scoped>

</style>
